document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('motion-ready');

const $ = (selector, context = document) => context.querySelector(selector);
const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];
const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[character]));

function toggleLayer(id, open) {
  const layer = document.getElementById(id);
  if (!layer) return;
  layer.classList.toggle('is-open', open);
  layer.setAttribute('aria-hidden', String(!open));
  document.body.classList.toggle('lock', open);
  if (open) setTimeout(() => $('input, button, a', layer)?.focus(), 180);
}

function money(cents, currency = 'EUR') {
  return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency }).format(cents / 100);
}

function cartMarkup(cart) {
  if (!cart.item_count) return '<div class="cart-drawer__empty"><p>Ihr Warenkorb ist leer.</p><a class="button button--dark" href="/collections/all">Container entdecken</a></div>';
  const items = cart.items.map(item => {
    const imageUrl = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=220` : '';
    const image = imageUrl ? `<img src="${escapeHTML(imageUrl)}" width="88" height="88" alt="${escapeHTML(item.product_title)}" loading="lazy">` : '';
    return `<div class="cart-drawer-item"><a href="${escapeHTML(item.url)}">${image}</a><div><a class="cart-drawer-item__title" href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a><small>${item.quantity} × ${money(item.final_price, cart.currency)}</small><button type="button" data-cart-remove="${escapeHTML(item.key)}">Entfernen</button></div></div>`;
  }).join('');
  return `<div class="cart-drawer__items">${items}</div><div class="cart-drawer__footer"><div><span>Zwischensumme</span><strong>${money(cart.total_price, cart.currency)}</strong></div><a class="button button--outline" href="/cart">Warenkorb ansehen</a><a class="button button--dark" href="/checkout">Sicher zur Kasse</a></div>`;
}

async function refreshCart(openDrawer = false) {
  const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then(response => response.json());
  $$('.cart-count').forEach(count => count.textContent = cart.item_count);
  $$('[data-cart-drawer-content]').forEach(content => content.innerHTML = cartMarkup(cart));
  if (openDrawer) toggleLayer('CartDrawer', true);
  return cart;
}

document.addEventListener('click', async event => {
  const opener = event.target.closest('[data-open]');
  if (opener) {
    event.preventDefault();
    if (opener.dataset.open === 'CartDrawer') await refreshCart();
    toggleLayer(opener.dataset.open, true);
  }
  const closer = event.target.closest('[data-close]');
  if (closer) {
    event.preventDefault();
    toggleLayer(closer.dataset.close, false);
  }
  const quantityButton = event.target.closest('[data-qty-change]');
  if (quantityButton) {
    const input = $('input[type="number"]', quantityButton.closest('[data-quantity]'));
    const next = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(quantityButton.dataset.qtyChange));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  const removeButton = event.target.closest('[data-cart-remove]');
  if (removeButton) {
    removeButton.disabled = true;
    await fetch(`${window.Shopify.routes.root}cart/change.js`, { method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: removeButton.dataset.cartRemove, quantity: 0 }) });
    await refreshCart();
  }
});

document.addEventListener('keydown', event => {
  if (event.key === 'Escape') $$('.is-open').forEach(layer => toggleLayer(layer.id, false));
});

$$('[data-slider]').forEach(slider => {
  const slides = $$('[data-slide]', slider);
  const dots = $$('[data-dot]', slider);
  if (slides.length < 2) return;
  let index = 0;
  const show = next => {
    slides[index].classList.remove('is-active');
    dots[index]?.classList.remove('is-active');
    index = next;
    slides[index].classList.add('is-active');
    dots[index]?.classList.add('is-active');
  };
  dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => show(dotIndex)));
  $('[data-slider-prev]', slider)?.addEventListener('click', () => show((index - 1 + slides.length) % slides.length));
  $('[data-slider-next]', slider)?.addEventListener('click', () => show((index + 1) % slides.length));
  if (slider.dataset.autoplay === 'true') setInterval(() => show((index + 1) % slides.length), Number(slider.dataset.speed || 6000));
});

$$('[data-product-form]').forEach(wrapper => {
  const select = $('[name="id"]', wrapper);
  const price = $('[data-product-price]');
  const button = $('[name="add"]', wrapper);
  select?.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    button.disabled = option.disabled;
    $('span', button).textContent = option.disabled ? (option.dataset.sold || 'Ausverkauft') : (option.dataset.add || 'In den Warenkorb');
  });
});

document.addEventListener('submit', async event => {
  if (!event.target.closest('[data-ajax-cart]')) return;
  if (event.submitter && event.submitter.name !== 'add') return;
  const form = event.target;
  event.preventDefault();
  const button = $('[type="submit"][name="add"]', form) || $('[type="submit"]', form);
  const original = button?.innerHTML;
  try {
    if (button) { button.disabled = true; button.textContent = 'Wird hinzugefügt …'; }
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Cart request failed');
    if (button) button.textContent = 'Hinzugefügt ✓';
    await refreshCart(true);
  } catch (error) {
    if (button) button.textContent = 'Bitte erneut versuchen';
  } finally {
    setTimeout(() => { if (button) { button.disabled = false; button.innerHTML = original; } }, 1400);
  }
});

$$('[data-product-recommendations]').forEach(async container => {
  try {
    const response = await fetch(container.dataset.url);
    const html = document.createElement('div');
    html.innerHTML = await response.text();
    const replacement = $('[data-product-recommendations]', html);
    if (replacement?.innerHTML.trim()) container.innerHTML = replacement.innerHTML;
  } catch (error) { /* Keep recommendations unobtrusive if unavailable. */ }
});

if ('IntersectionObserver' in window && !document.body.classList.contains('motion-disabled')) {
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
  }), { rootMargin: '0px 0px -30px', threshold: .08 });
  $$('.product-card,.category-card,.collection-showcase .section-head').forEach(element => { element.classList.add('reveal-ready'); observer.observe(element); });
  $$('main .shopify-section, main > section, .shopify-policy__container').forEach((element, order) => {
    if (element.classList.contains('section-reveal')) return;
    element.classList.add('section-reveal');
    element.style.setProperty('--reveal-delay', `${Math.min(order, 3) * 45}ms`);
    observer.observe(element);
  });
  document.addEventListener('shopify:section:load', event => event.target.classList.add('section-reveal', 'is-visible'));
}
